import httpClient from "./httpClient";


export const propertyClassApi = {
    list: async () => {
        return httpClient.get("propertyClass");
    }
}